import { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../../ModalContainer/ModelContainer'
import Icon from '../../../Icons'
import SuccessConfirmationModal from '../../../Popups/SuccessConfirmationModal'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import { selectActiveBuilding } from '../../../../reducers/buildingSelectorReducer'
import api from '../../../../api/api'

import AddReward from './components/AddReward/AddReward'
import UnlockRewardInfo from './components/UnlockRewardInfo/UnlockRewardInfo'
import SelectRewardType from './components/SelectRewardType/SelectRewardType'

const RewardsAddRewardModal = ({ onClose = () => {}, buildingData, selectedBuilding }) => {
  const { t } = useTranslation(['rewards-table', 'rewards'])
  const [currentView, setCurrentView] = useState('base')
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { displaySnackbar } = useSnackbar()
  const isAmenityRewardsAvailable = buildingData && buildingData.amenityRewardsAvailable

  const sendUpsellingMessage = async () => {
    try {
      setIsLoading(true)
      await api.sendUpsellingMessage({ type: 'amenityLoyaltyReward' }, selectedBuilding.id)
      setIsConfirmationVisible(true)
    } catch ({ message }) {
      displaySnackbar(message, true)
    } finally {
      setIsLoading(false)
    }
  }

  const views = {
    base: (
      <SelectRewardType
        onClose={onClose}
        amenityActive={isAmenityRewardsAvailable}
        setCurrentView={setCurrentView}
      />
    ),
    info: <UnlockRewardInfo onSendUpselling={sendUpsellingMessage} isLoading={isLoading} />,
    amenity: (
      <AddReward
        onBack={() => setCurrentView('base')}
        building={selectedBuilding}
        onClose={onClose}
      />
    ),
  }

  if (isConfirmationVisible) {
    return (
      <SuccessConfirmationModal
        header={t('rewards-table:addRewardModal.requestSentHeader')}
        description={t('rewards-table:addRewardModal.requestSentDescription')}
        handleClose={() => {
          setIsConfirmationVisible(false)
          onClose()
        }}
      />
    )
  }

  return (
    <ModalContainer
      additionalClass={'rewards-modal'}
      onClose={onClose}
      headerTitle={t('rewards:settingsToolbar.addRewardButton')}
      headerIcon={<Icon icon="cup" />}
    >
      {views[currentView]}
    </ModalContainer>
  )
}

RewardsAddRewardModal.propTypes = {
  onClose: PropTypes.func,
  selectedBuilding: PropTypes.object,
  buildingData: PropTypes.object,
}

export default connect((state) => ({ buildingData: selectActiveBuilding(state) }))(
  RewardsAddRewardModal,
)
